var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranslateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9.5625V0H1.6875C0.752344 0 0 0.752344 0 1.6875V34.3125C0 35.2477 0.752344 36 1.6875 36H25.3125C26.2477 36 27 35.2477 27 34.3125V11.25H17.4375C16.5094 11.25 15.75 10.4906 15.75 9.5625ZM20.333 24.7507H15.75V30.3757C15.75 30.9973 15.2466 31.5007 14.625 31.5007H12.375C11.7534 31.5007 11.25 30.9973 11.25 30.3757V24.7507H6.66703C5.66297 24.7507 5.16164 23.535 5.87461 22.827L12.6541 16.098C13.1217 15.6333 13.8769 15.6333 14.3445 16.098L21.124 22.827C21.8377 23.535 21.337 24.7507 20.333 24.7507ZM26.5078 7.38281L19.6242 0.492188C19.3078 0.175781 18.8789 0 18.4289 0H18V9H27V8.57109C27 8.12812 26.8242 7.69922 26.5078 7.38281Z",
    fill: "#5E66EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateIcon);
export default __webpack_public_path__ + "static/media/TranslateIcon.229866126fecb782e049c5df92793df6.svg";
export { ForwardRef as ReactComponent };